import Axios from "axios";
import { ApiResultModel } from "../models/common.model";
import {
  GetSalesSearchRequest,
  GetSalesSearchResponse,
  SalesSearchFilter,
} from "../models/sale.model";
import { ApiBaseUrl, Sale } from "../config/config";

export const GetSalesSearch = async (
  data: GetSalesSearchRequest
): Promise<ApiResultModel<GetSalesSearchResponse[]>> => {
  return await Axios.post<ApiResultModel<GetSalesSearchResponse[]>>(
    ApiBaseUrl + Sale + "/GetSalesSearch",
    data
  ).then((result) => {
    return result.data;
  });
};

export const GetSalesSearchExcel = async (data: SalesSearchFilter) => {
  return await Axios({
    method: "POST",
    url: ApiBaseUrl + Sale + "/GetSalesSearchExcel",
    data,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/pdf",
    },
  }).then((response: any) => {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", `${"تاریخچه فاکتورهای فروش"}.xlsx`);
    document.body.appendChild(link);
    link.click();
  });
};
